export const getSelectedSlicerValues = async (report) => {
  const pages = await report.getPages()
  let activePage = pages.find((page) => page.isActive == true)

  const visuals = await activePage.getVisuals()
  const slicers = await visuals.filter((visual) => visual.type === "slicer")

  let selectedSlicers = []

  for (const slice of slicers) {
    let slicerState = await slice.getSlicerState()
    if (slicerState.filters.length > 0) {
      selectedSlicers.push({
        column: slicerState.filters[0].target.column,
        title: slice.title,
        values: slicerState.filters[0].values,
      })
    }
  }

  return selectedSlicers
}
